/**
 * @file   hug-enum.js 拥抱你的枚举工具
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2020-04-23
 */
import {each, assign, hasOwnProperty, isPlain} from './obj';

export default class HugEnum extends Array {
    constructor(object) {
        super();

        if (isPlain(object)) {
            each(object, (item, key) => {
                if (hasOwnProperty(object, key)) {
                    item['key'] = key;
                    this.push(item);
                }
            });
        } else if (Array.isArray(object)) {
            object.forEach((item, key) => {
                item.key = item.key !== undefined ? item.key : key;
                this[item.key] = item;
            });
            this.push(...object);
        }

        /**
        * 通过key或者value获取对应配置项
        *
        * @param {*} val 某一项配置的key或者value
        * @return {Object} 对应配置项
        */
        this.get = val => {
            return this.getByKey(val) || this.getByVal(val) || {};
        };

        /**
        * 通过key获取对应配置项
        *
        * @param {string} key 某一项配置的key
        * @return {Object} 对应配置项
        */
        this.getByKey = key => {
            return this.find(item => item.key === key);
        };

        /**
        * 通过value获取对应配置项
        *
        * @param {*} val 某一项配置的value
        * @return {Object} 对应配置项
        */
        this.getByVal = val => {
            return this.find(item => item.value === val);
        };

        /**
        * 通过key或者value获取对应配置项的label
        *
        * @param {*} val 某一项配置的key或者value
        * @return {Object} 对应配置项的label
        */
        this.getLabel = val => {
            return (this.get(val) || {}).label || '';
        };
    }
}
